import script from "./inde.vue?vue&type=script&lang=ts&setup=true"
export * from "./inde.vue?vue&type=script&lang=ts&setup=true"

import "./inde.vue?vue&type=style&index=0&id=048243c6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-048243c6"]])

export default __exports__